export default "__VITE_ASSET__BjYcSQtR__"